import React, { PureComponent } from "react";
import {
  getTrans,
  makeClasses,
  createTeamData,
  setLocalStorage,
  hasTeam,
  customTracking,
} from "../../common";
import { Consume } from "../../Context/Consumer";
import {
  WebConfigDataContext,
  ConstraintsContext,
  TransContext,
  FixturesContext,
  CompositionContext,
  TeamDataContext,
  PlayerListContext,
  PlayerRecommendationContext,
  LoginContext,
} from "../../Context/index";
import { filter } from "lodash";
import config from "../../common/config";
import $ from "jquery";
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks,
} from "body-scroll-lock";
import OutsideNotifier from "../OutsideNotifier";
import { Fragment } from "react";

class FormationPopUp extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedFormation: this.props.CompositionData.activeComposition,
    };
  }

  createArray = (numb) => {
    var arr = [];
    for (let i = 0; i < numb; i++) {
      arr.push({ index: i });
    }
    return arr;
  };

  closeFormationPopUp = (outside) => {
    if (
      this.state.selectedFormation.CompId !=
        this.props.CompositionData.activeComposition.CompId &&
      !outside
    ) {
      let def = this.state.selectedFormation.DEF;
      let mid = this.state.selectedFormation.MID;
      let fwd = this.state.selectedFormation.FWD;
      let formationString = def + "-" + mid + "-" + fwd;
      // customTracking("Change Formation - " + formationString, "/" + config.GAME_NAME + "/my-team/manage/")
      setLocalStorage("lastFormation", this.state.selectedFormation);
      this.props.FixturesData.setScreenMode(config.screenMode.substitution);
      this.props.CompositionData.setActiveComposition(
        this.state.selectedFormation
      );
      this.props.goToSubs(undefined, this.state.selectedFormation);
    }
    this.props.CompositionData.setFormationPopUpVisiblity(false);
  };

  onFormationClick = (comp) => {
    if (comp.IsActive) {
      // if (config.isMobile) {
      if (comp.CompId != this.state.selectedFormation.CompId) {
        this.setState({
          selectedFormation: comp,
        });
      }

      // } else {
      //     if (comp.CompId != this.props.CompositionData.activeComposition.CompId) {
      //         if (hasTeam() && isLoggedIn()) {

      //             setLocalStorage("lastFormation", comp)
      //             this.props.FixturesData.setScreenMode(config.screenMode.substitution);
      //             this.props.CompositionData.setActiveComposition(comp);
      //             this.props.goToSubs(undefined, comp);
      //         }

      //     } else {
      //         if (config.isMobile) {
      //             this.setState({
      //                 selectedFormation: comp
      //             })
      //         } else {
      //             setLocalStorage("lastFormation", comp)
      //             this.props.CompositionData.setActiveComposition(comp);

      //             let creatTeamObj = {
      //                 constraints: this.props.ConstraintsData.data,
      //                 formations: this.props.CompositionData.data,
      //                 newFormationId: comp.CompId,
      //                 playerPos: config.playerPos,
      //                 teamData: this.props.TeamData.data,

      //             }
      //             let teamData = createTeamData(creatTeamObj);

      //             this.props.TeamData.setTeamData(teamData);
      //         }

      //     }
      // }
    }
  };

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  componentDidMount() {
    // this.setState({
    //   selectedFormation: this.props.CompositionData.activeComposition,
    // });
    // disableBodyScroll();
    // if (config.isMobile) {
    //   $(".si-formation__wrapper").animate(
    //     { scrollLeft: $("#si-mostSelected").offset().left - 50 },
    //     500
    //   );
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.selectedFormation.CompId !== this.state.selectedFormation.CompId
    ) {
      this.closeFormationPopUp(false);
    }
  }

  render() {
    let trans = this.props.TransData.data;
    // let formationsData = this.props.CompositionData.data;
    let formationsData = [];
    let isButtonDisabled =
      this.state.selectedFormation.CompId ==
      this.props.CompositionData.activeComposition.CompId;

    for (let [key, value] of Object.entries(this.props.CompositionData.data)) {
      formationsData.push(value);
    }
    const defaultFormationCompID =
      this.props.CompositionData.activeComposition.CompId;
    formationsData = formationsData.filter((formation) => {
      if (formation) {
        return +formation.CompId !== 9;
      }
    });
    const formationList = formationsData.map((formation) => {
      let fwd = formation.FWD;
      let mid = formation.MID;
      let def = formation.DEF;
      let formationStr = def + "-" + mid + "-" + fwd;

      let isCompositionActive = false;
      // if (config.isMobile) {
      if (formation.CompId == this.state.selectedFormation.CompId) {
        isCompositionActive = true;
      }
      const defaultClasses = makeClasses({
        // "si-formation__type": true,
        "si-active": isCompositionActive,
        "si-tt-active":
          formation.CompId == this.props.ConstraintsData.data.mostPickedComp
            ? true
            : false,
        // "si-disabled": !formation.IsActive,
        "si-mostPicked": formation.IsTopSelected,
      });
      const clickHandler = formation.IsActive
        ? {
            onClick: (e) => {
              this.onFormationClick(formation);
              // this.closeFormationPopUp();
            },
          }
        : {};
      let positionArray = [
        { lable: "fwd", dots: this.createArray(fwd) },
        { lable: "mid", dots: this.createArray(mid) },
        { lable: "def", dots: this.createArray(def) },
      ];

      return (
        <li key={formationStr} className={defaultClasses} {...clickHandler}>
          {/* si-active | si-mostPicked */}
          <div className="si-formation__box">
            <div className="si-formation__mostPicked">
              <span>Most Picked</span>
            </div>
            <div className="si-formation__box-title">
              <span>{formationStr}</span>
            </div>
            <div className="si-formation__box-thumb">
              {/* <img src={config.IMG_BASE + "pitch.png"} alt="" title="" /> */}
              <img
                // src={`../images/formation/${formationStr}.png`}
                src={`${config.IMG_BASE}formation/${formationStr}.png?v=${config.WebConfig.imgVersion}`}
                alt={formationStr}
                title={formationStr}
              />
            </div>
          </div>

          {/* <div className="si-formation__txt">{formationStr}</div>
          <div className="si-formation__position">
            {positionArray.map(function (obj) {
              return (
                <div
                  key={obj.lable}
                  className={
                    "si-formation__cols si-formation--" + obj.dots.length
                  }
                >
                  {obj.dots.map(function (inDots, index) {
                    return (
                      <span
                        key={inDots.index}
                        className="si-formation--dot"
                      ></span>
                    );
                  })}
                </div>
              );
            })}
          </div>
    */}
        </li>
      );
    });

    return (
      <Fragment>
        <div className="si-popup__wrap si-formation__popup si-fade in">
          <OutsideNotifier
            handler={(e) => {
              e.stopPropagation();

              this.closeFormationPopUp(false);
            }}
          >
            {/* in | out */}
            <div className="si-popup__container">
              <div className="si-popup__head">
                <div className="si-popup__heading">
                  <span>
                    {getTrans(trans, "choseFormation", "Choose Formation")}
                  </span>
                </div>
                <div
                  className="si-popup__close"
                  onClick={() => {
                    this.closeFormationPopUp(false);
                  }}
                >
                  <div className="si-btn__adRe"></div>
                </div>
                {/* <div className="si-popup__head-btn">
                  <div
                    className={
                      isButtonDisabled
                        ? "si-btn si-btn__primary si-disabled"
                        : "si-btn si-btn__primary"
                    }
                    style={{ display: "block !important" }}
                    onClick={(e) => {
                      e.stopPropagation();

                      this.closeFormationPopUp(false);
                    }}
                  >
                    <span>{getTrans(trans, "confirm", "Confirm")}</span>
                  </div>
                </div> */}
              </div>
              <div className="si-popup__body">
                <div className="si-formation__list">
                  <ul>{formationList}</ul>
                </div>
              </div>
            </div>
          </OutsideNotifier>
        </div>

        {/* <div className="si-modal si-active">
          <OutsideNotifier
            handler={(e) => {
              this.closeFormationPopUp(e, true);
            }}
          >
            <div className={"si-popup--formation si-curved-sm si-active"}>
              <div className="si-bg--pattern"></div>
              <div className="si-popup__header">
                <div className="si-popup__head">
                  {getTrans(trans, "choseFormation", "Choose Formation")}
                </div>
                <div
                  className={
                    isButtonDisabled
                      ? "si-btn si-btn--primary si-disabled"
                      : "si-btn si-btn--primary"
                  }
                  style={{ display: "block !important" }}
                  onClick={(e) => {
                    this.closeFormationPopUp(e, false);
                  }}
                >
                  {getTrans(trans, "confirm", "confirm")}
                </div>
                <div className="si-btn si-btn--primary" onClick={ (e) => { this.closeFormationPopUp(e, false) } }>  { getTrans(trans, "confirm", "confirm") }</div>
              </div>
              <div className="si-popup__body">
                <div className="si-formation__wrapper">{formationList}</div>
              </div>
            </div>
          </OutsideNotifier>
        </div>
     */}
      </Fragment>
    );
  }
}

export default Consume(FormationPopUp, [
  WebConfigDataContext,
  ConstraintsContext,
  TransContext,
  FixturesContext,
  CompositionContext,
  TeamDataContext,
  PlayerListContext,
  PlayerRecommendationContext,
  LoginContext,
]);
